/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PrefsService } from 'src/app/services/prefs.service';
import { restoreFocusOnDismissModal } from 'src/app/utils/overlay-controller.utils';
import { HowToTextPage } from '../how-to-text/how-to-text.page';

@Component({
  selector: 'app-how-to',
  templateUrl: './how-to.page.html',
  styleUrls: ['./how-to.page.scss']
})
export class HowToPage implements OnInit {
  isLongDistance = false;

  constructor(
    private modalCtrl: ModalController,
    private prefs: PrefsService
  ) {}

  async presentModal(page, item) {
    const pageMap = { howToText: HowToTextPage };
    const modal = await this.modalCtrl.create({ component: pageMap[page], componentProps: { topic: item } });
    restoreFocusOnDismissModal(modal);
    await modal.present();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  init() {
    this.prefs.getPromiseOrDefault('ldMode').then((res: boolean) => {
      this.isLongDistance = res;
    });
  }

  ionViewWillEnter() {
    this.init();
  }

  ngOnInit() {}
}
